import React, { useContext } from "react";
import { SiteContext } from "@arcteryx/components-contexts";
import Script from "./Script";
import PropTypes from "prop-types";

const UIFooterElement = ({ market, country, language }) => {
  return React.createElement(`arcteryx-${market}-footer`, { country, language, id: "arcteryx-footer" });
};

const UIFooter = ({ uiBaseUrl = '', env, loadScript = false, ...props }) => {
  const { market, country, language } = useContext(SiteContext);
  const footerUrl = `${uiBaseUrl}/${country}/${language}/${market}Footer.js`;

  return (
    <>
      {loadScript ? <Script url={footerUrl} async={false} defer={true} {...props} /> : null}
      <UIFooterElement market={market} country={country} language={language} />
    </>
  );
};

UIFooter.propTypes = {
  env: PropTypes.oneOf(["production", "stage", "qa"]),
  loadScript: PropTypes.bool,
};

export default UIFooter;
